
class TabbedProductsSection extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll(".tab-button");
    this.tabContents = this.querySelectorAll(".tab-content");
    this.splideInstances = new Map(); // Store Splide instances for each tab

    this.initTabs();
    this.initSplide();
  }

  // Initialize tab functionality
  initTabs() {
    this.tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const tabId = button.dataset.tab;
        this.showTab(tabId);
      });
    });
  }

  // Show the selected tab and hide others
  showTab(tabId) {
    // Update button states
    this.tabButtons.forEach((button) => {
      button.classList.toggle("active", button.dataset.tab === tabId);
    });

    // Update content visibility
    this.tabContents.forEach((content) => {
      const isActive = content.dataset.tab === tabId;
      content.classList.toggle("active", isActive);

      // Refresh Splide when tab becomes active
      if (isActive) {
        const splideInstance = this.splideInstances.get(tabId);
        if (splideInstance) {
          splideInstance.refresh(); // Refresh Splide to ensure proper rendering
        }
      }
    });
  }

  // Initialize Splide carousels for each tab
  initSplide() {
    this.tabContents.forEach((content) => {
      const tabId = content.dataset.tab;
      const splideElement = content.querySelector(".splide");

      if (splideElement && !this.splideInstances.has(tabId)) {
        const splide = new Splide(splideElement, {
          type:'loop',
          perPage: 4,
          perMove: 1,
          perPage:5,
          gap: "2rem",
          pagination: true,
          arrows: true,
          breakpoints: {
            767: {
              perPage: 2,
              gap: "0.5rem",
            },
            1024: {
              perPage: 3,
            },
          },
        });

        splide.mount();
        this.splideInstances.set(tabId, splide); // Store Splide instance for later use
      }
    });
  }

  // Clean up Splide instances when the element is disconnected
  disconnectedCallback() {
    this.splideInstances.forEach((splide) => {
      splide.destroy(); // Destroy Splide instances to avoid memory leaks
    });
  }
}

// Define the custom element
customElements.define("tabbed-products-section", TabbedProductsSection);
